import type { KeyboardEvent } from 'react';

/**
 * Which way an arrow key moves through a row of items, in the direction the
 * row is actually laid out. In RTL the next item is to the *left*; hard-coding
 * ArrowRight as "next" is the classic bug that only shows in Arabic.
 *
 * Returns +1, -1, 'first', 'last', or null for any other key.
 */
export function arrowStep(event: KeyboardEvent<HTMLElement>, orientation: 'horizontal' | 'vertical' | 'both' = 'horizontal'): 1 | -1 | 'first' | 'last' | null {
  const rtl = getComputedStyle(event.currentTarget).direction === 'rtl';
  const horizontal = orientation !== 'vertical';
  const vertical = orientation !== 'horizontal';

  switch (event.key) {
    case 'ArrowLeft':
      return horizontal ? (rtl ? 1 : -1) : null;
    case 'ArrowRight':
      return horizontal ? (rtl ? -1 : 1) : null;
    case 'ArrowDown':
      return vertical ? 1 : null;
    case 'ArrowUp':
      return vertical ? -1 : null;
    case 'Home':
      return 'first';
    case 'End':
      return 'last';
    default:
      return null;
  }
}

/** The index an arrow step lands on, wrapping at both ends. */
export function nextIndex(step: 1 | -1 | 'first' | 'last', current: number, count: number): number {
  if (step === 'first') return 0;
  if (step === 'last') return count - 1;

  return (current + step + count) % count;
}
